import styled from 'styled-components';

export const Tabs = styled.div.withConfig({ displayName: '-Tabs' })`
	display: flex;
	flex-direction: row;
	border-left: 1px solid #C4C4C4;
`;
